import { render, staticRenderFns } from "./onChange-editor.vue?vue&type=template&id=4d21c55c&scoped=true&"
import script from "./onChange-editor.vue?vue&type=script&lang=js&"
export * from "./onChange-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d21c55c",
  null
  
)

export default component.exports